<template>
  <div class="addressSelectBox">
    <el-form-item v-if="!isSearch"
      :label="addressName + (colonsItem ? '：' : '')"
      :required="required"
      :class="{'address-form-item__inline': inlineItem, 'justify-form_label': justifyItem}"
    >
      <el-row type="flex" :gutter="0" justify="space-between" :class="{'address': validFail && isPrompt}">
        <el-col :span="4">
          <el-select
            clearable
            filterable
            value-key="districtCode"
            size="mini"
            @change="handleProvinceChange"
            v-model="provinceData"
            placeholder="省"
            :disabled="disabled"
          >
            <el-option
              v-for="item in provinceNames"
              :key="item.districtCode"
              :value="item"
              :label="item.districtValue"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            clearable
            filterable
            value-key="districtCode"
            size="mini"
            @change="handleCityChange"
            v-model="cityData"
            placeholder="市"
            :disabled="disabled"
          >
            <el-option
              v-for="item in cityNames"
              :key="item.districtCode"
              :value="item"
              :label="item.districtValue"
            ></el-option>
          </el-select>
        </el-col>

        <el-col :span="4">
          <el-select
            clearable
            filterable
            value-key="districtCode"
            size="mini"
            @change="handleDistrictChange"
            v-model="districtData"
            placeholder="区"
            :disabled="disabled"
          >
            <el-option
              v-for="item in districtNames"
              :key="item.districtCode"
              :value="item"
              :label="item.districtValue"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="10">
          <el-input
            v-if="showDetailAddress"
            class="not_require"
            size="mini"
            v-model="form.addressData"
            placeholder="详细地址"
            clearable
            :disabled="disabled"
            @blur="handleChange"
            @clear="handleChange"
          ></el-input>
        </el-col>
      </el-row>
      <span v-if="validFail && isPrompt" class="warning_text">请选择并输入详细地址</span>
    </el-form-item>
    <el-form-item v-if="isSearch" class="search-box">
      <el-row type="flex" :gutter="0" justify="space-between">
        <el-col style="padding-right: 8px;">
          <el-select
            clearable
            filterable
            value-key="districtCode"
            size="mini"
            @change="handleProvinceChange"
            v-model="provinceData"
            placeholder="选择省"
          >
            <el-option
              v-for="item in provinceNames"
              :key="item.districtCode"
              :value="item"
              :label="item.districtValue"
            ></el-option>
          </el-select>
        </el-col>
        <el-col style="padding-right: 8px;">
          <el-select
            clearable
            filterable
            value-key="districtCode"
            size="mini"
            @change="handleCityChange"
            v-model="cityData"
            placeholder="选择市"
          >
            <el-option
              v-for="item in cityNames"
              :key="item.districtCode"
              :value="item"
              :label="item.districtValue"
            ></el-option>
          </el-select>
        </el-col>

        <el-col>
          <el-select
            clearable
            filterable
            value-key="districtCode"
            size="mini"
            @change="handleDistrictChange"
            v-model="districtData"
            placeholder="选择区"
          >
            <el-option
              v-for="item in districtNames"
              :key="item.districtCode"
              :value="item"
              :label="item.districtValue"
            ></el-option>
          </el-select>
        </el-col>
        <!-- <el-col>
          <el-input
            style="margin-left:8px;"
            v-if="showDetailAddress"
            class="not_require"
            size="mini"
            v-model="form.addressData"
            placeholder="详细地址"
            clearable
            :disabled="disabled"
            @blur="handleChange"
            @clear="handleChange"
          ></el-input>
        </el-col> -->
      </el-row>
    </el-form-item>
  </div>
</template>

<script>
import { district } from '@/api/Sys'

export default {
  // 如果需要缓存页面
  // name 字段需要设置为和本页路由 name 字段一致
  name: 'AddreassSelect',
  components: {},
  props: {
    gutter: {
      type: Number,
      default: 0
    },
    // 控制刷新
    refresh: {
      type: Boolean,
      default: false
    },
    // 初始数据
    initData: {
      type: Object,
      required: false,
      default: null,
      deep: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    inlineItem: {
      type: Boolean,
      required: false,
      default: false
    },
    justifyItem: {
      type: Boolean,
      required: false,
      default: false
    },
    colonsItem: {
      type: Boolean,
      required: false,
      default: true
    },
    warning: {
      type: Boolean,
      required: false,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    addressName: {
      type: String,
      default: '项目地址'
    },
    showDetailAddress: {
      type: Boolean,
      default: true,
    },
    isPrompt: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      provinceData: {},
      cityData: {},
      districtData: {},
      form: {
        provinceName: '',
        provinceCode: '',
        cityName: '',
        cityCode: '',
        districtName: '',
        districtCode: '',
        addressData: ''
      },
      provinceNames: [],
      cityNames: [],
      districtNames: [],
      validFail: false
    }
  },
  async created() {
    const res = await district(0)
    if (res && res.data) {
      this.provinceNames = res.data
    }
  },
  watch: {
    warning: function(value) {
      this.validFail = value;
    },
    refresh: function(newRefresh, oldRefresh) {
      this.provinceData = {}
      this.cityData = {}
      this.districtData = {}
      this.form = {
        provinceName: '',
        provinceCode: '',
        cityName: '',
        cityCode: '',
        townName: '',
        townCode: '',
        addressData: ''
      }
      this.cityNames = []
      this.districtNames = []

      this.handleChange()
    },
    initData: function(newData, oldData) {
  
      if (newData) {
        this.form = { ...this.initData }
        if (this.initData.provinceCode) {
          this.provinceData = {
            districtValue: this.initData.provinceName,
            districtCode: this.initData.provinceCode
          }
          district(this.initData.provinceCode).then(res => {
            if (res && res.data) {
              this.cityNames = res.data
            }
          })
        }
        if (this.initData.cityCode) {
          this.cityData = {
            districtValue: this.initData.cityName,
            districtCode: this.initData.cityCode
          }
          district(this.initData.cityCode).then(res => {
            if (res && res.data) {
              this.districtNames = res.data
            }
          })
        }
        if (this.initData.townCode) {
          this.districtData = {
            districtValue: this.initData.townName,
            districtCode: this.initData.townCode
          }
        }
      }
    }
  },
  mounted() {
    console.log(this.initData)
  },
  methods: {
    async handleProvinceChange(val) {
      if (!val) {
        this.form = {
          provinceName: '',
          provinceCode: '',
          cityName: '',
          cityCode: '',
          townName: '',
          townCode: '',
          addressData: ''
        }
        this.provinceData = {}
        this.cityData = {}
        this.districtData = {}
        this.cityNames = []
        this.districtNames = []
        this.handleChange()
        return
      }
      // 记住重置市和区
      this.form = {
        ...this.form,
        provinceName: val.districtValue,
        provinceCode: val.districtCode,
        cityName: '',
        cityCode: '',
        townName: '',
        townCode: '',
        addressData: ''
      }
      this.handleChange()
      this.cityData = {}
      this.districtData = {}
      const res = await district(val.id)
      if (res && res.data) {
        this.cityNames = res.data
      }
    },
    async handleCityChange(val) {
      if (!val) {
        this.form = {
          ...this.form,
          cityName: '',
          cityCode: '',
          townName: '',
          townCode: '',
          addressData: ''
        }
        this.cityData = {}
        this.districtData = {}
        this.districtNames = []
        this.handleChange()
        return
      }
      this.form = {
        ...this.form,
        cityName: val.districtValue,
        cityCode: val.districtCode,
        townName: '',
        townCode: '',
        addressData: ''
      }
      this.handleChange()
      this.districtData = {}
      const res = await district(val.id)
      if (res && res.data) {
        this.districtNames = res.data
      }
    },
    handleDistrictChange(val) {
      if (!val) {
        this.form.townName = ''
        this.form.townCode = ''
        this.form.addressData = '';
        this.handleChange()
        return
      }
      this.form = {
        ...this.form,
        townName: val.districtValue,
        townCode: val.districtCode,
        addressData: ''
      }
      this.handleChange()
    },
    handleChange() {
      let data = Object.assign({}, this.form);
      delete data.districtName;
      delete data.districtCode;
      let hasEmpty = false;
      for(let key in data) {
        if (!data[key] && key !== 'addressData') {
          hasEmpty = true;
        }
      }
      this.validFail = hasEmpty;
      this.$emit('change', data)
    }
  }
}
</script>
<style lang="scss">
  .address .el-input__inner {
    border-color: #F56C6C;
  }
  .el-form--inline .search-form-btns__container .search-box {
    margin-top: 0px;
  }
  .el-form--inline .addressBoxItem .search-box {
    margin-bottom: 0px;
  }
  .warning_text {
    color: #fa5046;
    font-size: 12px;
    font-weight: 500;
    line-height: 1;
    position: absolute;
    top: 36px;
    left: 0;
  }
  .not_require .el-input__inner {
    border-color: rgb(204, 204, 204);
  }
</style>



// WEBPACK FOOTER //
// src/components/AddreassSelect/AddreassSelect.vue